import { useRemoteScreenShareComponent } from "../../video-sdk/actions/useComponentActions";
import { useRemoteScreenShare } from "../useRemoteScreenShare";
import { ScreenShareVideoLayout } from "./ScreenShareVideoLayout";

export function RemoteScreenShare() {
  const {
    remoteParticipantScreenShareRef,
    remoteParticipantAudioScreenShareRef,
  } = useRemoteScreenShare();

  const RemoteScreenShareComponent = useRemoteScreenShareComponent();

  return (
    <ScreenShareVideoLayout>
      <RemoteScreenShareComponent
        videoRef={remoteParticipantScreenShareRef}
        audioRef={remoteParticipantAudioScreenShareRef}
      />
    </ScreenShareVideoLayout>
  );
}
